export default {
      id: "ic_bahista_eye_open-usage",
      viewBox: "0 0 20 14",
      url: "/" + "images/icons.3.109.2.svg#ic_bahista_eye_open-usage",
      toString: function () {
        return this.url;
      }
    }